import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/login-certificata.png'


const _withScopeId = n => (_pushScopeId("data-v-3d0cf384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-all" }
const _hoisted_2 = { class: "recover" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "recover-thumb" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "hero-image-fade",
    preview: false
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "hero-content" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "hero-fade hero-fade-1" }, [
      /*#__PURE__*/_createTextVNode(" Assinatura eletrônica "),
      /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0664ce"} }, "segura "),
      /*#__PURE__*/_createTextVNode(" e "),
      /*#__PURE__*/_createElementVNode("span", { style: {"color":"#56c24d"} }, "confiável")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "hero-fade hero-fade-2" }, " Tecnologia e segurança para simplificar seu dia a dia e proteger o que importa. "),
    /*#__PURE__*/_createElementVNode("div", { class: "hero-features" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "hero-fade hero-fade-3" }, "🔒 Segurança ponta a ponta"),
      /*#__PURE__*/_createElementVNode("span", { class: "hero-fade hero-fade-4" }, "👥 Múltiplos signatários"),
      /*#__PURE__*/_createElementVNode("span", { class: "hero-fade hero-fade-5" }, "📄 Validade jurídica")
    ])
  ])
], -1))
const _hoisted_4 = { class: "recover-content" }
const _hoisted_5 = { class: "recover-wrapper" }
const _hoisted_6 = { class: "recover-card" }
const _hoisted_7 = { class: "recover-content-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Acesso ao Sistema",
  preview: false
}, null, -1))
const _hoisted_9 = { class: "recover-content-form" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "success-title" }
const _hoisted_12 = { class: "success-subtitle" }
const _hoisted_13 = { class: "form-cp" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-label" }, "Email", -1))
const _hoisted_15 = { class: "form-cp" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-label" }, "Nova senha", -1))
const _hoisted_17 = { class: "form-cp" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-label" }, "Confirme a senha", -1))
const _hoisted_19 = {
  key: 0,
  class: "error-password"
}
const _hoisted_20 = { class: "form-action" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" CANCELAR ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("section", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("h2", null, _toDisplayString(_ctx.titleMain), 1)
            ]),
            _createElementVNode("section", _hoisted_9, [
              (_ctx.sendMail || _ctx.resetAccount)
                ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                    _createVNode(_component_CheckCircleFilled, { class: "success-ic" }),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.subTitle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.insertMail)
                ? (_openBlock(), _createBlock(_component_a_form, {
                    key: 1,
                    layout: "vertical",
                    class: "form"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_a_input, {
                          value: _ctx.email,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                          placeholder: "seu@email.com",
                          size: "large"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_MailOutlined)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.recoverAccount)
                ? (_openBlock(), _createBlock(_component_a_form, {
                    key: 2,
                    layout: "vertical",
                    class: "form"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_a_input_password, {
                          value: _ctx.password,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          placeholder: "*******"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_a_input_password, {
                          value: _ctx.passwordConfirmation,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                          placeholder: "*******"
                        }, null, 8, ["value"])
                      ]),
                      (_ctx.differentPasswords)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, " *As duas senhas devem ser iguais "))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.recoverAccount || _ctx.insertMail)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      size: "larger",
                      class: "btn-cancel",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.replace({ name: 'authenticator' })))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "larger",
                  class: "btn-primary",
                  onClick: _ctx.nextStep
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createVNode(_component_Footer)
        ])
      ])
    ])
  ]))
}